import { FileText } from "lucide-react";

export default function TermsPage() {
  return (
    <div className="py-12 md:py-16 px-4 bg-content min-h-screen" data-testid="terms-page">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-amber-500/20 bg-amber-500/5 text-amber-400 text-xs font-medium mb-3">
            <FileText className="w-3 h-3" /> Legal
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2" data-testid="terms-heading">Terms of Service</h1>
          <p className="text-sm text-slate-500">Last updated: April 2026</p>
        </div>

        <div className="prose-invert space-y-6 text-slate-400 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">1. Acceptance of Terms</h2>
            <p>By accessing or using EasyQuickFund's website and services, you agree to be bound by these Terms of Service. If you do not agree, do not use our services.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">2. Services</h2>
            <p>EasyQuickFund provides a platform connecting businesses with funding solutions through our network of lending partners. We are not a direct lender. All funding decisions are made by our lending partners.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">3. Eligibility</h2>
            <p>You must be at least 18 years old and authorized to act on behalf of the business entity applying for funding. You represent that all information provided is accurate and complete.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">4. Application Process</h2>
            <p>Submitting an application does not guarantee funding. All applications are subject to review and approval by our lending partners. Pre-qualification does not constitute a binding offer.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">5. ACH Authorization</h2>
            <p>By completing the ACH authorization form, you authorize EasyQuickFund and/or its lending partners to initiate electronic fund transfers to and from your designated bank account in accordance with the terms agreed upon.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">6. Limitation of Liability</h2>
            <p>EasyQuickFund shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">7. Governing Law</h2>
            <p>These Terms shall be governed by the laws of the United States. Any disputes shall be resolved in the appropriate courts of jurisdiction.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">8. Contact</h2>
            <p>For questions about these Terms, contact: <span className="text-amber-400">applications@easyquickfund.com</span></p>
          </section>
        </div>
      </div>
    </div>
  );
}
